import { getMissionCardLifecycleState, type CardFirstMissionCard } from './lifecycle';

export interface TriageMissionLike {
  id: string;
  title?: string;
  state?: CardFirstMissionCard['state'];
  status?: CardFirstMissionCard['status'];
  snoozedUntil?: number;
  entityConfidence?: number;
  confidence?: number;
  needsReview?: boolean;
  needs_review?: boolean;
  reviewRequired?: boolean;
}

const TRIAGE_LIMIT = 5;
const LOW_CONFIDENCE_THRESHOLD = 0.55;

function needsTriage(mission: TriageMissionLike): boolean {
  if (mission.needsReview || mission.needs_review || mission.reviewRequired) return true;
  const confidence = typeof mission.entityConfidence === 'number'
    ? mission.entityConfidence
    : mission.confidence;
  return typeof confidence === 'number' && Number.isFinite(confidence) && confidence < LOW_CONFIDENCE_THRESHOLD;
}

export function selectTriageMissions<T extends TriageMissionLike>(missions: T[], now = Date.now()): T[] {
  return missions
    .filter(mission => {
      const state = getMissionCardLifecycleState(mission as unknown as CardFirstMissionCard, now);
      if (state === 'dismissed' || state === 'completed' || state === 'expired' || state === 'snoozed') {
        return false;
      }
      return needsTriage(mission);
    })
    .slice(0, TRIAGE_LIMIT);
}
